import { Link } from "react-router-dom";

export function LandingPage() {
  return (
    <div className="shell">
      <nav className="platform-nav">
        <div className="brand-mark">
          DUTS <span>Business</span>
        </div>
        <div className="cta-row">
          <Link className="btn btn-secondary" to="/login">
            Log in
          </Link>
          <Link className="btn btn-primary" to="/signup">
            Create with AI
          </Link>
        </div>
      </nav>
      <section className="hero-landing">
        <div className="hero-copy">
          <p className="eyebrow">AI website & business app platform</p>
          <h1>
            Describe your business. AI builds the website and customer app.
          </h1>
          <p>
            Launch a professional branded site with booking and a client portal
            — without learning design, SEO, or software. Cleaning and
            landscaping first; more service industries next.
          </p>
          <div className="cta-row">
            <Link className="btn btn-primary" to="/signup">
              Start creating
            </Link>
            <Link className="btn btn-secondary" to="/login">
              Owner login
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
